import * as React from 'react'
import styled from 'styled-components'

import { StyledSVG } from 'reusable/SVG'
import { getApartmentStatus } from 'utils/helper'

const Floor17StyledSVG = styled(StyledSVG)`
  #up,
  #up:hover {
    cursor: not-allowed;
    .cls-3 {
      fill: #e6e7e8;
    }
  }
`

export default function Floor17({
  activeApartment,
  changeFloor,
  changeView,
  hLookAt,
  apartments,
}) {
  const [elementOnHover, setElementOnHover] = React.useState('')
  const { sceneName, apartmentNumber } = activeApartment

  return (
    <Floor17StyledSVG id="floor-17" viewBox="0 0 360 240">
      <defs>
        <style>
          {`
          .cls-1 {
            fill: url(#linear-gradient);
          }

          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {
            stroke-width: 0px;
          }

          .cls-2 {
            fill: #ececec;
          }

          .cls-3 {
            fill: #e6e7e8;
          }

          .cls-12 {
            fill: none;
          }

          .cls-12, .cls-13, .cls-14 {
            stroke-miterlimit: 10;
            stroke-width: 2px;
          }

          .cls-12, .cls-14 {
            stroke: #141414;
          }

          .cls-5 {
            fill-rule: evenodd;
          }

          .cls-5, .cls-11 {
            fill: #143275;
          }

          .cls-6 {
            fill: #fff;
          }

          .cls-7, .cls-13 {
            fill: #939598;
          }

          .cls-8 {
            fill: url(#linear-gradient-2);
          }

          .cls-9 {
            fill: url(#linear-gradient-3);
          }

          .cls-13 {
            stroke: #231f20;
          }

          .cls-14 {
            fill: #d6d6d6;
          }

          .cls-10 {
            fill: #505050;
            opacity: .99;
          }
        `}
        </style>
        <symbol id="arrow_google_down" viewBox="0 0 18.3 18.3">
          <use
            width="18.3"
            height="18.3"
            transform="translate(18.3 18.3) rotate(-180)"
            xlinkHref="#arrow_google_up"
          />
        </symbol>
        <symbol id="arrow_google_up" viewBox="0 0 18.3 18.3">
          <path
            id="arrow_up_2"
            className="cls-11"
            d="m7.45,6.55l-5.05,5.025-2.4-2.425L9.15,0l9.15,9.15-2.4,2.45-5.05-5.05v11.75s-3.4,0-3.4,0V6.55Z"
          />
        </symbol>
        <linearGradient
          id="linear-gradient"
          x1="251.2365"
          y1="-2175.128"
          x2="251.2365"
          y2="-2218.5401"
          gradientTransform="translate(-164.9032 -1960.2159) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="289.2383"
          y1="-2175.2061"
          x2="289.2383"
          y2="-2218.6182"
          gradientTransform="translate(-164.9032 -1960.2159) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="340.4012"
          y1="-2175.2061"
          x2="340.4012"
          y2="-2218.6182"
          gradientTransform="translate(-164.9032 -1960.2159) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" />
          <stop offset="0" stopColor="#fff" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <g id="bg-16" data-name="bg">
        <rect
          id="bg-17"
          data-name="bg"
          className="cls-2"
          width="360"
          height="240"
        />
        <polygon
          id="house_base"
          data-name="house base"
          className="cls-13"
          points="223.6247 203 197.3333 203 74.1398 203 39.3333 203 39.3333 139.8698 39.3333 114.3333 39.3333 101.3333 28.6667 101.3333 20.6667 37.6667 28.8333 37.6667 216 37.6667 223.6247 37.6667 223.6247 203"
        />
        <polygon
          id="compass_arrow"
          data-name="compass arrow"
          className="cls-4"
          points="255 107.3652 243.4272 115.704 246.3741 118.0503 235 132.3365 235.3747 132.6348 246.7488 118.3486 253.7194 109.5934 249.4607 120.5077 249.7803 120.7621 255 107.3652"
        />
        <path
          id="skanska_logo"
          className="cls-5"
          d="m317.471,210.9275h2.4783l-1.2465-3.7971-1.2318,3.7971Zm3.8116,4.0725l-.6667-2.0434h-3.7971l-.6667,2.0434h-2.4203l3.5072-10h2.942l3.5072,10h-2.4057Zm-10.4203-10h2.7247l-3.8406,4.9275,3.8406,5.0725h-2.8261l-3.145-4.1739v4.1739h-2.3188v-10h2.3188v4.1885l3.2464-4.1885Zm-9.9855,3.9275c1.9276,0,3.116,1.087,3.116,3.0145,0,1.9131-1.1884,3.058-3.116,3.058h-4.9999v-2.116h4.9711c.6521,0,.9855-.4637.9855-.942s-.3334-.9419-.9855-.9419h-2.2609c-1.9276,0-3.1159-1.1161-3.1159-2.971,0-1.8986,1.1884-3.0291,3.1159-3.0291h4.7102v2.1159h-4.6812c-.6522,0-.9856.4494-.9856.9132,0,.4492.3334.8984.9856.8984h2.2608Zm-9.1159,2.3189v-6.2464h2.3188v10h-2.4057l-3.9711-6.2608v6.2608h-2.3189v-10h2.4058l3.9711,6.2464Zm-13.4493-.3188h2.4783l-1.2464-3.7971-1.2319,3.7971Zm-.2318-5.9275h2.9419l3.5072,10h-2.4058l-.6666-2.0434h-3.7972l-.6665,2.0434h-2.4203l3.5072-10Zm-6.3768,0h2.7246l-3.8406,4.9275,3.8406,5.0725h-2.8261l-3.1449-4.1739v4.1739h-2.3188v-10h2.3188v4.1885l3.2464-4.1885Zm-9.9855,3.942c1.9276,0,3.1159,1.0869,3.1159,3s-1.1884,3.058-3.1159,3.058h-5v-2.1305h4.971c.6522,0,.9856-.4638.9856-.9275,0-.4782-.3333-.9419-.9856-.9419h-2.2609c-1.9276,0-3.1159-1.1161-3.1159-2.971,0-1.8986,1.1884-3.0291,3.1159-3.0291h4.7102v2.1304h-4.6812c-.6522,0-.9855.4493-.9855.8986,0,.4637.3333.913.9855.913h2.2609Z"
        />
        <g>
          <path
            className="cls-11"
            d="m243.873,34.6816h-3.6699v3.4043h4.0898v1.0225h-5.3086v-9.4414h5.0996v1.0225h-3.8809v2.9844h3.6699v1.0078Z"
          />
          <path
            className="cls-11"
            d="m245.6621,37.8477c.3652.2383,1.0098.4902,1.625.4902.8965,0,1.3164-.4482,1.3164-1.0088,0-.5879-.3496-.9102-1.2598-1.2461-1.2188-.4346-1.793-1.1064-1.793-1.9189,0-1.0928.8828-1.9893,2.3398-1.9893.6855,0,1.2871.1963,1.666.4199l-.3086.8965c-.2656-.168-.7559-.3916-1.3867-.3916-.7285,0-1.1348.4199-1.1348.9238,0,.5605.4062.8125,1.2891,1.1484,1.1777.4482,1.7793,1.0371,1.7793,2.0459,0,1.1904-.9238,2.0303-2.5352,2.0303-.7422,0-1.4297-.1816-1.9062-.4619l.3086-.9385Z"
          />
          <path
            className="cls-11"
            d="m251.375,34.542c0-.8682-.0293-1.5693-.0566-2.2129h1.1074l.0547,1.1621h.0293c.5039-.8262,1.3027-1.3164,2.4082-1.3164,1.6387,0,2.873,1.3867,2.873,3.4453,0,2.4375-1.4863,3.6426-3.082,3.6426-.8965,0-1.6816-.3926-2.0879-1.0645h-.0273v3.6836h-1.2188v-7.3398Zm1.2188,1.8066c0,.1826.0273.3506.0547.5049.2246.8545.9668,1.4424,1.8496,1.4424,1.3027,0,2.0586-1.0645,2.0586-2.6191,0-1.3594-.7129-2.5215-2.0156-2.5215-.8418,0-1.625.6025-1.8633,1.5264-.043.1543-.084.3369-.084.5049v1.1621Z"
          />
          <path
            className="cls-11"
            d="m265.4766,35.6621c0,2.5078-1.7383,3.6006-3.377,3.6006-1.834,0-3.25-1.3447-3.25-3.4883,0-2.2695,1.4863-3.5996,3.3633-3.5996,1.9453,0,3.2637,1.415,3.2637,3.4873Zm-5.3789.0703c0,1.4854.8535,2.6055,2.0586,2.6055,1.1758,0,2.0586-1.1064,2.0586-2.6338,0-1.1484-.5742-2.6045-2.0312-2.6045s-2.0859,1.3447-2.0859,2.6328Z"
          />
          <path
            className="cls-11"
            d="m273.1621,35.6621c0,2.5078-1.7363,3.6006-3.375,3.6006-1.8359,0-3.25-1.3447-3.25-3.4883,0-2.2695,1.4844-3.5996,3.3613-3.5996,1.9473,0,3.2637,1.415,3.2637,3.4873Zm-5.3789.0703c0,1.4854.8555,2.6055,2.0586,2.6055,1.1777,0,2.0605-1.1064,2.0605-2.6338,0-1.1484-.5742-2.6045-2.0312-2.6045s-2.0879,1.3447-2.0879,2.6328Z"
          />
          <path
            className="cls-11"
            d="m274.7129,34.1641c0-.7012-.0137-1.2754-.0566-1.835h1.0938l.0684,1.1201h.0293c.3359-.6445,1.1191-1.2744,2.2402-1.2744.9395,0,2.3965.5605,2.3965,2.8857v4.0479h-1.2344v-3.9082c0-1.0928-.4043-2.0029-1.5684-2.0029-.8125,0-1.4414.5742-1.6523,1.2607-.0566.1543-.084.3643-.084.5742v4.0762h-1.2324v-4.9443Z"
          />
          <path
            className="cls-11"
            d="m290.3809,34.6816h-3.6699v3.4043h4.0898v1.0225h-5.3086v-9.4414h5.0977v1.0225h-3.8789v2.9844h3.6699v1.0078Z"
          />
          <path
            className="cls-11"
            d="m293.7812,30.3818v1.9473h1.7656v.9385h-1.7656v3.6553c0,.8408.2383,1.3174.9238,1.3174.3223,0,.5605-.042.7148-.084l.0566.9238c-.2383.0986-.6172.168-1.0938.168-.5742,0-1.0352-.1816-1.3301-.5176-.3496-.3643-.4766-.9668-.4766-1.7656v-3.6973h-1.0508v-.9385h1.0508v-1.625l1.2051-.3223Z"
          />
          <path
            className="cls-11"
            d="m297.5332,35.9424c.0273,1.667,1.0918,2.3535,2.3242,2.3535.8828,0,1.416-.1543,1.877-.3506l.2109.8828c-.4336.1963-1.1777.4199-2.2559.4199-2.0859,0-3.334-1.3721-3.334-3.417s1.2051-3.6562,3.1797-3.6562c2.2129,0,2.8027,1.9473,2.8027,3.1934,0,.252-.0293.4482-.043.5742h-4.7617Zm3.6133-.8818c.0137-.7852-.3223-2.0029-1.709-2.0029-1.2461,0-1.793,1.1484-1.8906,2.0029h3.5996Z"
          />
          <path
            className="cls-11"
            d="m303.8594,29.1631h1.2324v9.9453h-1.2324v-9.9453Z"
          />
          <path
            className="cls-11"
            d="m310.918,39.1084l-.0977-.8545h-.043c-.377.5322-1.1055,1.0088-2.0723,1.0088-1.373,0-2.0742-.9668-2.0742-1.9473,0-1.6387,1.457-2.5352,4.0762-2.5215v-.1396c0-.5605-.1543-1.5693-1.541-1.5693-.6289,0-1.2871.1963-1.7637.5049l-.2812-.8125c.5605-.3643,1.373-.6025,2.2285-.6025,2.0723,0,2.5762,1.415,2.5762,2.7734v2.5352c0,.5889.0293,1.1631.1133,1.625h-1.1211Zm-3.4043-8.6982c0-.3926.3223-.7148.7148-.7148s.6855.3086.6855.7148c0,.3779-.2793.7139-.6855.7139-.4199,0-.7148-.3359-.7148-.7139Zm3.2227,5.2383c-1.3457-.0283-2.873.21-2.873,1.5273,0,.7979.5332,1.1758,1.1641,1.1758.8809,0,1.4414-.5596,1.6387-1.1338.041-.127.0703-.2666.0703-.3926v-1.1768Zm-.6172-5.2383c0-.3926.3086-.7148.7012-.7148.3906,0,.6855.3086.6855.7148,0,.3779-.2793.7139-.6855.7139-.4199,0-.7012-.3359-.7012-.7139Z"
          />
          <path
            className="cls-11"
            d="m314.2754,32.3291l1.3301,3.8096c.2246.6162.4062,1.1768.5469,1.7373h.043c.1543-.5605.3496-1.1211.5742-1.7373l1.3164-3.8096h1.2891l-2.6621,6.7793h-1.1758l-2.5781-6.7793h1.3164Z"
          />
          <path
            className="cls-11"
            d="m321.9062,30.4238c.0137.4199-.293.7559-.7832.7559-.4355,0-.7441-.3359-.7441-.7559,0-.4346.3223-.7705.7715-.7705.4629,0,.7559.3359.7559.7705Zm-1.373,8.6846v-6.7793h1.2324v6.7793h-1.2324Z"
          />
          <path
            className="cls-11"
            d="m325.1816,30.4238c.0137.4199-.293.7559-.7832.7559-.4355,0-.7441-.3359-.7441-.7559,0-.4346.3223-.7705.7715-.7705.4629,0,.7559.3359.7559.7705Zm-1.373,8.6846v-6.7793h1.2324v6.7793h-1.2324Z"
          />
          <path
            className="cls-11"
            d="m328.5703,30.3818v1.9473h1.7656v.9385h-1.7656v3.6553c0,.8408.2383,1.3174.9238,1.3174.3223,0,.5605-.042.7148-.084l.0566.9238c-.2383.0986-.6172.168-1.0938.168-.5742,0-1.0352-.1816-1.3301-.5176-.3496-.3643-.4766-.9668-.4766-1.7656v-3.6973h-1.0508v-.9385h1.0508v-1.625l1.2051-.3223Z"
          />
          <path
            className="cls-11"
            d="m333.2051,30.3818v1.9473h1.7637v.9385h-1.7637v3.6553c0,.8408.2363,1.3174.9238,1.3174.3223,0,.5605-.042.7148-.084l.0547.9238c-.2383.0986-.6152.168-1.0918.168-.5742,0-1.0371-.1816-1.3301-.5176-.3516-.3643-.4766-.9668-.4766-1.7656v-3.6973h-1.0508v-.9385h1.0508v-1.625l1.2051-.3223Z"
          />
          <path
            className="cls-11"
            d="m340.1074,39.1084l-.0977-.8545h-.043c-.377.5322-1.1055,1.0088-2.0723,1.0088-1.373,0-2.0742-.9668-2.0742-1.9473,0-1.6387,1.457-2.5352,4.0762-2.5215v-.1396c0-.5605-.1543-1.5693-1.541-1.5693-.6289,0-1.2871.1963-1.7637.5049l-.2812-.8125c.5605-.3643,1.373-.6025,2.2285-.6025,2.0723,0,2.5762,1.415,2.5762,2.7734v2.5352c0,.5889.0293,1.1631.1133,1.625h-1.1211Zm-.1816-3.46c-1.3457-.0283-2.873.21-2.873,1.5273,0,.7979.5332,1.1758,1.1641,1.1758.8809,0,1.4414-.5596,1.6387-1.1338.041-.127.0703-.2666.0703-.3926v-1.1768Z"
          />
        </g>
        <g>
          <path
            className="cls-7"
            d="m347.2402,164.7461v1.8457h-.666v-4.4922h.666v1.8545h5.4023v.792h-5.4023Z"
          />
          <path
            className="cls-7"
            d="m347.0605,160.6787c.2695-.0098.4863.1885.4863.5039,0,.2793-.2168.4766-.4863.4766-.2793,0-.4961-.207-.4961-.4951,0-.2969.2168-.4854.4961-.4854Zm5.582.8818h-4.3574v-.792h4.3574v.792Z"
          />
          <path
            className="cls-7"
            d="m350.6074,159.0137c1.0723-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0977-.9092-.2246-1.2061l.5684-.1357c.125.2793.2695.7568.2695,1.4502,0,1.3408-.8828,2.1426-2.1973,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.252-1.8008,2.0527-1.8008.1621,0,.2891.0186.3691.0273v3.0605Zm-.5664-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7363,1.1523,1.2871,1.2148v-2.3135Z"
          />
          <path
            className="cls-7"
            d="m347.0332,153.9922h1.252v-1.1348h.6035v1.1348h2.3496c.5391,0,.8457-.1533.8457-.5947,0-.207-.0273-.3594-.0547-.459l.5957-.0361c.0625.1533.1074.3965.1074.7021,0,.3691-.1172.667-.334.8555-.2344.2256-.6211.3066-1.1328.3066h-2.377v.6748h-.6035v-.6748h-1.0449l-.207-.7744Z"
          />
          <path
            className="cls-7"
            d="m350.4277,148.0771c1.6113,0,2.3125,1.1162,2.3125,2.1699,0,1.1797-.8633,2.0889-2.2402,2.0889-1.459,0-2.3145-.9551-2.3145-2.1611,0-1.251.9102-2.0977,2.2422-2.0977Zm.0449,3.457c.9531,0,1.6738-.5488,1.6738-1.3232,0-.7559-.7109-1.3232-1.6914-1.3232-.7383,0-1.6758.3691-1.6758,1.3057,0,.9355.8652,1.3408,1.6934,1.3408Z"
          />
          <path
            className="cls-7"
            d="m352.6426,144.667l-.5488.0635v.0273c.3418.2422.6465.7109.6465,1.332,0,.8818-.6211,1.332-1.25,1.332-1.0547,0-1.6309-.9355-1.6211-2.6191h-.0898c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.125.8281.3242,1.1338l-.5234.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9102-1.6562,1.7832-1.6562h1.6289c.3789,0,.748-.0186,1.0449-.0723v.7197Zm-2.2246.1172c-.0176.8643.1348,1.8457.9824,1.8457.5117,0,.7559-.3418.7559-.7471,0-.5674-.3613-.9277-.7305-1.0537-.0801-.0264-.1699-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-7"
            d="m351.7324,140.8975c.1445-.2256.3691-.748.3691-1.2969,0-1.0176-.6484-1.332-1.1348-1.3232-.8184.0088-1.1699.7471-1.1699,1.5127v.4404h-.5938v-.4404c0-.5762-.2969-1.3057-.9902-1.3057-.4688,0-.8828.2969-.8828,1.0264,0,.4678.207.918.3867,1.1699l-.5762.207c-.2246-.3057-.4492-.9004-.4492-1.5303,0-1.1523.6836-1.6748,1.3945-1.6748.6035,0,1.1172.3604,1.3789,1.0811h.0176c.1445-.7207.6836-1.3057,1.5039-1.3057.9355,0,1.7539.7295,1.7539,2.1338,0,.6572-.207,1.2334-.3945,1.5215l-.6133-.2158Z"
          />
          <path
            className="cls-7"
            d="m347.3477,133.1289c-.0078.1621,0,.3691.0371.5938.207,1.2432,1.1152,1.9004,2.0801,2.0352v-.0273c-.3691-.2793-.6758-.7646-.6758-1.4131,0-1.0352.748-1.7646,1.8906-1.7646,1.0703,0,2.0605.7295,2.0605,1.9443,0,1.252-.9707,2.0713-2.4922,2.0713-1.1523,0-2.0625-.4141-2.6387-.9902-.4766-.4863-.7734-1.1348-.8633-1.873-.0371-.2344-.0449-.4316-.0449-.5762h.6465Zm3.377.2246c-.8379,0-1.3418.4775-1.3418,1.207,0,.4766.2969.918.7207,1.1338.0898.0547.207.0908.3516.0908.9629-.0186,1.6738-.46,1.6738-1.2881,0-.6836-.5664-1.1436-1.4043-1.1436Z"
          />
          <path
            className="cls-7"
            d="m349.6523,127.9639c1.9902,0,3.0879.7383,3.0879,2.0342,0,1.1436-1.0703,1.918-3.0059,1.9355-1.9629,0-3.043-.8457-3.043-2.0342,0-1.2334,1.0977-1.9355,2.9609-1.9355Zm.0918,3.1777c1.5215,0,2.3848-.4678,2.3848-1.1885,0-.8105-.9453-1.1973-2.4395-1.1973-1.4414,0-2.3867.3691-2.3867,1.1885,0,.6934.8477,1.1973,2.4414,1.1973Z"
          />
          <path
            className="cls-7"
            d="m349.9766,119.9346c-.8457.0449-1.8633.0996-2.6191.0898v.0273c.7109.207,1.4668.459,2.3047.7656l2.9434,1.0713v.5938l-2.8887.9814c-.8555.2881-1.6387.5312-2.3594.7021v.0176c.7559.0186,1.7734.0635,2.6836.1172l2.6016.1621v.7471l-6.0684-.4229v-.999l2.9355-1.0352c.7461-.2529,1.4121-.46,2.043-.6123v-.0273c-.6113-.1533-1.2793-.3691-2.043-.6387l-2.9355-1.0811v-.999l6.0684-.3779v.7646l-2.666.1533Z"
          />
          <path
            className="cls-7"
            d="m352.6426,115.373l-.5488.0635v.0273c.3418.2432.6465.7109.6465,1.332,0,.8818-.6211,1.332-1.25,1.332-1.0547,0-1.6309-.9355-1.6211-2.6191h-.0898c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.125.8281.3242,1.1338l-.5234.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9102-1.6562,1.7832-1.6562h1.6289c.3789,0,.748-.0186,1.0449-.0723v.7197Zm-2.2246.1172c-.0176.8643.1348,1.8457.9824,1.8457.5117,0,.7559-.3418.7559-.7471,0-.5674-.3613-.9277-.7305-1.0537-.0801-.0264-.1699-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-7"
            d="m347.0605,112.5664c.2695-.0098.4863.1885.4863.5039,0,.2793-.2168.4766-.4863.4766-.2793,0-.4961-.207-.4961-.4951,0-.2969.2168-.4854.4961-.4854Zm5.582.8818h-4.3574v-.792h4.3574v.792Z"
          />
          <path
            className="cls-7"
            d="m351.832,111.4502c.1523-.2344.3145-.6484.3145-1.0449,0-.5762-.2871-.8457-.6484-.8457-.377,0-.584.2246-.8008.8096-.2793.7832-.7109,1.1523-1.2324,1.1523-.7031,0-1.2793-.5664-1.2793-1.5029,0-.4414.127-.8281.2695-1.0713l.5762.1982c-.1074.1709-.252.4854-.252.8906,0,.4688.2715.7295.5957.7295.3594,0,.5215-.2607.7383-.8281.2871-.7559.666-1.1436,1.3125-1.1436.7656,0,1.3066.5947,1.3066,1.6299,0,.4766-.1172.918-.2969,1.2236l-.6035-.1973Z"
          />
          <path
            className="cls-7"
            d="m350.6074,107.3369c1.0723-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0977-.9092-.2246-1.2061l.5684-.1357c.125.2793.2695.7568.2695,1.4502,0,1.3408-.8828,2.1426-2.1973,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.252-1.8008,2.0527-1.8008.1621,0,.2891.0186.3691.0273v3.0605Zm-.5664-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7363,1.1523,1.2871,1.2148v-2.3135Z"
          />
          <path
            className="cls-7"
            d="m349.4648,103.2686c-.4512,0-.8203.0088-1.1797.0361v-.6934l.7012-.0361v-.0264c-.4141-.2432-.8008-.6484-.8008-1.3691,0-.5938.3594-1.0439.873-1.2334v-.0176c-.2422-.1348-.4316-.3066-.5664-.4863-.1992-.2607-.3066-.5488-.3066-.9629,0-.5762.3789-1.4316,1.8906-1.4316h2.5664v.7744h-2.4668c-.8379,0-1.3418.3057-1.3418.9453,0,.4502.334.8008.7207.9355.1074.0361.252.0635.3965.0635h2.6914v.7744h-2.6113c-.6934,0-1.1973.3057-1.1973.9092,0,.4951.3965.8555.793.9814.1172.0449.252.0625.3867.0625h2.6289v.7744h-3.1777Z"
          />
          <path
            className="cls-7"
            d="m352.6426,93.3496l-.5488.0635v.0273c.3418.2432.6465.7109.6465,1.332,0,.8818-.6211,1.332-1.25,1.332-1.0547,0-1.6309-.9355-1.6211-2.6191h-.0898c-.3594,0-1.0078.0986-1.0078.9902,0,.4053.125.8281.3242,1.1338l-.5234.1807c-.2344-.3604-.3867-.8828-.3867-1.4316,0-1.332.9102-1.6562,1.7832-1.6562h1.6289c.3789,0,.748-.0186,1.0449-.0723v.7197Zm-2.2246.1172c-.0176.8643.1348,1.8457.9824,1.8457.5117,0,.7559-.3418.7559-.7471,0-.5674-.3613-.9277-.7305-1.0537-.0801-.0264-.1699-.0449-.252-.0449h-.7559Z"
          />
          <path
            className="cls-7"
            d="m350.2832,90.6416v-.0176c-.1523-.1084-.3418-.2617-.4941-.3877l-1.5039-1.2783v-.9541l1.791,1.6836,2.5664-1.918v.9639l-2.0898,1.5029.4512.4053h1.6387v.7832h-6.3926v-.7832h4.0332Z"
          />
          <path
            className="cls-7"
            d="m350.4277,83.2607c1.6113,0,2.3125,1.1162,2.3125,2.1699,0,1.1797-.8633,2.0889-2.2402,2.0889-1.459,0-2.3145-.9551-2.3145-2.1611,0-1.251.9102-2.0977,2.2422-2.0977Zm.0449,3.457c.9531,0,1.6738-.5488,1.6738-1.3232,0-.7559-.7109-1.3232-1.6914-1.3232-.7383,0-1.6758.3691-1.6758,1.3057,0,.9355.8652,1.3408,1.6934,1.3408Z"
          />
          <path
            className="cls-7"
            d="m349.4648,82.2627c-.4512,0-.8203.0088-1.1797.0361v-.7021l.7207-.0449v-.0186c-.4141-.2158-.8203-.7197-.8203-1.4404,0-.6025.3594-1.5391,1.8555-1.5391h2.6016v.792h-2.5117c-.7031,0-1.2871.2617-1.2871,1.0088,0,.5215.3691.9268.8086,1.0615.0996.0361.2344.0547.3691.0547h2.6211v.792h-3.1777Z"
          />
          <path
            className="cls-7"
            d="m350.6074,76.8271c1.0723-.0176,1.5117-.7021,1.5117-1.4941,0-.5674-.0977-.9092-.2246-1.2061l.5684-.1357c.125.2793.2695.7568.2695,1.4502,0,1.3408-.8828,2.1426-2.1973,2.1426s-2.3496-.7744-2.3496-2.0439c0-1.4229,1.252-1.8008,2.0527-1.8008.1621,0,.2891.0186.3691.0273v3.0605Zm-.5664-2.3223c-.5039-.0088-1.2871.207-1.2871,1.0986,0,.8008.7363,1.1523,1.2871,1.2148v-2.3135Z"
          />
        </g>
      </g>
      <g id="apartments-16" data-name="apartments">
        <g
          onClick={() => changeView(17, 'talosauna2')}
          onMouseOver={() => setElementOnHover('talosauna2')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <polygon
            id="talosauna_2"
            className={`cls-14 ${
              sceneName === 'scene_17krs_talosauna2'
                ? 'active-apt'
                : elementOnHover === 'talosauna2'
                ? 'on-hover'
                : ''
            } ${getApartmentStatus(apartments, 'talosauna2')}`}
            points="39.3333 203 39.3333 187.0833 75.9167 187.0833 75.9167 174.9167 96.2222 174.9167 96.2222 219.3333 75.3333 218.4444 75.3889 203 39.3333 203"
          />
        </g>
        <g
          onClick={() => changeView(17, 'talosauna3')}
          onMouseOver={() => setElementOnHover('talosauna3')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <polygon
            id="talosauna_2"
            className={`cls-14 ${
              sceneName === 'scene_17krs_talosauna3'
                ? 'active-apt'
                : elementOnHover === 'talosauna3'
                ? 'on-hover'
                : ''
            } ${getApartmentStatus(apartments, 'talosauna3')}`}
            points="88.3333 174.9167 88.3333 143.5833 105.9167 143.5833 105.9167 171.6667 122.1457 171.6667 122.1457 176.8333 154.75 176.8333 154.75 220.75 121.25 220.75 96.2222 219.3333 96.2222 174.9167 88.3333 174.9167"
          />
        </g>
        <g
          onClick={() => changeView(17, 'talokerho2')}
          onMouseOver={() => setElementOnHover('talokerho2')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <polygon
            id="talosauna_2"
            className={`cls-14 ${
              sceneName === 'scene_17krs_talokerho2'
                ? 'active-apt'
                : elementOnHover === 'talokerho2'
                ? 'on-hover'
                : ''
            } ${getApartmentStatus(apartments, 'talokerho2')}`}
            points="154.75 176.8333 174.6667 176.8333 174.6667 145.6667 154.75 145.6667 154.75 127.5833 168.3889 127.5833 168.3889 112.5556 183 112.5556 183 120.25 223.6247 120.25 223.6247 203 195.9089 203 199 220.75 154.75 218.4167 154.75 176.8333"
          />
        </g>
        <polygon
          id="talosauna_1"
          className="cls-14"
          points="39.3333 187.0833 39.3333 158.5833 75.9167 158.5833 75.9167 174.9167 75.9167 187.0833 39.3333 187.0833"
        />
      </g>
      <g id="borders_extra-16" data-name="borders_extra">
        <line className="cls-12" x1="74.1398" y1="203" x2="197.3333" y2="203" />
        <polyline
          className="cls-12"
          points="75.9167 158.5833 75.9167 97.5 223.6247 97.5 223.6247 120.25"
        />
      </g>
      <g id="view-16" data-name="view">
        {apartmentNumber === 'talosauna2' && (
          <g id="sauna_2">
            <path
              id="cone"
              className="cls-1"
              d="m89.5958,214.9314c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z"
              transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
            />
            <circle
              id="location"
              className="cls-6"
              cx={`${pivots[apartmentNumber][0]}`}
              cy={`${pivots[apartmentNumber][1]}`}
              r="1.6046"
            />
          </g>
        )}
        {apartmentNumber === 'talosauna3' && (
          <g id="sauna_3">
            <path
              id="cone-2"
              data-name="cone"
              className="cls-8"
              d="m127.5975,215.0095c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z"
              transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
            />
            <circle
              id="location-2"
              data-name="location"
              className="cls-6"
              cx={`${pivots[apartmentNumber][0]}`}
              cy={`${pivots[apartmentNumber][1]}`}
              r="1.6046"
            />
          </g>
        )}
        {apartmentNumber === 'talokerho2' && (
          <g id="kerhotila-2" data-name="kerhotila">
            <path
              id="cone-3"
              data-name="cone"
              className="cls-9"
              d="m178.7605,215.0095c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z"
              transform={`rotate(${hLookAt} ${pivots[apartmentNumber][0]} ${pivots[apartmentNumber][1]})`}
            />
            <circle
              id="location-3"
              data-name="location"
              className="cls-6"
              cx={`${pivots[apartmentNumber][0]}`}
              cy={`${pivots[apartmentNumber][1]}`}
              r="1.6046"
            />
          </g>
        )}
      </g>
      <g id="elevator-16" data-name="elevator">
        <g id="bg_tausta" data-name="bg tausta">
          <path
            className="cls-11"
            d="m310,155c0,11-9,20-20,20h0c-11,0-20-9-20-20v-70c0-11,9-20,20-20h0c11,0,20,9,20,20v70Z"
          />
        </g>
        <g id="down" data-name="down" onClick={() => changeFloor('down')}>
          <g id="bg-18" data-name="bg">
            <circle className="cls-3" cx="290" cy="155" r="17" />
          </g>
          <use
            width="18.3"
            height="18.3"
            transform="translate(280.85 145.85)"
            xlinkHref="#arrow_google_down"
          />
        </g>
        <g id="up" data-name="up">
          <g id="bg-19" data-name="bg">
            <circle className="cls-3" cx="290" cy="85" r="17" />
          </g>
          {/* <use
            width="18.3"
            height="18.3"
            transform="translate(280.85 75.85)"
            xlinkHref="#arrow_google_up"
          /> */}
        </g>
        <g>
          <path
            className="cls-6"
            d="m282.7988,112.0889h-.0527l-2.9375,1.5859-.4414-1.7422,3.6914-1.9756h1.9512v16.9004h-2.2109v-14.7686Z"
          />
          <path
            className="cls-6"
            d="m302.1426,109.957v1.5078l-7.3574,15.3926h-2.3672l7.332-14.9502v-.0527h-8.2676v-1.8975h10.6602Z"
          />
        </g>
      </g>
      <g id="apartment_nr-16" data-name="apartment_nr">
        <g
          id="sauna_2-2"
          data-name="sauna_2"
          onClick={() => changeView(17, 'talosauna2')}
          onMouseOver={() => setElementOnHover('talosauna2')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <path
            className="cls-10"
            d="m47.0215,197.8184v-1.7188c.3125.2607.6504.457,1.0156.5879s.7344.1953,1.1064.1953c.2178,0,.4092-.0195.5713-.0586.1641-.0391.2998-.0938.4082-.1641.1094-.0693.1914-.1523.2451-.2471s.0811-.1973.0811-.3086c0-.1504-.043-.2842-.1289-.4033-.0859-.1172-.2031-.2266-.3516-.3271-.1494-.1006-.3262-.1973-.5293-.29-.2051-.0928-.4248-.1875-.6611-.2852-.6016-.25-1.0498-.5566-1.3447-.918-.2969-.3613-.4434-.7988-.4434-1.3105,0-.4014.0801-.7461.2412-1.0342s.3799-.5254.6572-.7119c.2783-.1855.5996-.3223.9648-.4102s.752-.1318,1.1602-.1318c.4004,0,.7559.0244,1.0664.0723.3096.0488.5957.123.8564.2236v1.6055c-.1289-.0898-.2695-.168-.4209-.2363-.1523-.0684-.3096-.124-.4707-.1689s-.3213-.0781-.4805-.0996c-.1602-.0215-.3105-.0322-.4541-.0322-.1963,0-.376.0186-.5371.0566-.1611.0371-.2979.0898-.4082.1582s-.1963.1494-.2578.2441-.0908.2012-.0908.3203c0,.1289.0332.2441.1016.3457.0684.1025.1641.1992.29.29.126.0918.2773.1807.4561.2686.1797.0879.3818.1787.6074.2715.3086.1289.584.2656.8301.4111.2451.1445.4551.3086.6309.4912s.3096.3916.4023.626c.0938.2344.1406.5068.1406.8193,0,.4297-.082.79-.2441,1.082-.1641.292-.3848.5283-.6641.709s-.6035.3105-.9746.3887c-.3711.0791-.7617.1191-1.1738.1191-.4219,0-.8242-.0361-1.2051-.1074-.3828-.0723-.7129-.1797-.9922-.3223Z"
          />
          <path
            className="cls-10"
            d="m57.9521,198.1133h-1.6064v-.7891h-.0215c-.3682.6152-.9141.9238-1.6377.9238-.5342,0-.9541-.1514-1.2588-.4541-.3066-.3027-.46-.7061-.46-1.2119,0-1.0664.6318-1.6826,1.8955-1.8477l1.4941-.1982c0-.6016-.3262-.9023-.9785-.9023-.6543,0-1.2773.1953-1.8691.585v-1.2773c.2363-.1221.5605-.2295.9707-.3223.4092-.0938.7832-.1406,1.1191-.1406,1.5684,0,2.3525.7832,2.3525,2.3477v3.2871Zm-1.5947-2.2344v-.3711l-1,.1289c-.5508.0723-.8262.3213-.8262.7471,0,.1934.0664.3516.2012.4756.1348.123.3164.1855.5449.1855.3184,0,.5781-.1104.7793-.3311.2002-.2197.3008-.498.3008-.835Z"
          />
          <path
            className="cls-10"
            d="m64.5215,198.1133h-1.6924v-.8379h-.0264c-.4199.6484-.9805.9727-1.6816.9727-1.2754,0-1.9121-.7725-1.9121-2.3154v-3.3193h1.6914v3.1689c0,.7773.3086,1.165.9238,1.165.3047,0,.5488-.1064.7305-.3193.1836-.2129.2744-.502.2744-.8672v-3.1475h1.6924v5.5Z"
          />
          <path
            className="cls-10"
            d="m71.2617,198.1133h-1.6914v-3.0566c0-.8516-.3047-1.2773-.9141-1.2773-.293,0-.5352.1123-.7246.3379s-.2852.5117-.2852.8594v3.1367h-1.6973v-5.5h1.6973v.8701h.0215c.4053-.6699.9941-1.0049,1.7676-1.0049,1.2168,0,1.8262.7559,1.8262,2.2676v3.3672Z"
          />
          <path
            className="cls-10"
            d="m77.1807,198.1133h-1.6064v-.7891h-.0215c-.3682.6152-.9141.9238-1.6377.9238-.5342,0-.9541-.1514-1.2588-.4541-.3066-.3027-.46-.7061-.46-1.2119,0-1.0664.6318-1.6826,1.8955-1.8477l1.4941-.1982c0-.6016-.3262-.9023-.9785-.9023-.6543,0-1.2773.1953-1.8691.585v-1.2773c.2363-.1221.5605-.2295.9707-.3223.4092-.0938.7832-.1406,1.1191-.1406,1.5684,0,2.3525.7832,2.3525,2.3477v3.2871Zm-1.5947-2.2344v-.3711l-1,.1289c-.5508.0723-.8262.3213-.8262.7471,0,.1934.0664.3516.2012.4756.1348.123.3164.1855.5449.1855.3184,0,.5781-.1104.7793-.3311.2002-.2197.3008-.498.3008-.835Z"
          />
          <path
            className="cls-10"
            d="m83.373,196.6738v.0322h3.127v1.4072h-5.0703v-1.3213l2.207-2.1104c.4434-.4268.7559-.7842.9375-1.0723.1807-.2881.2715-.5918.2715-.9102,0-.709-.3818-1.0635-1.1445-1.0635-.6621,0-1.2969.2627-1.9014.79v-1.4941c.6689-.4326,1.4248-.6494,2.2666-.6494.7871,0,1.4023.1982,1.8447.5938s.6631.9297.6631,1.6025c0,.8994-.5391,1.8281-1.6162,2.7881l-1.585,1.4072Z"
          />
        </g>
        <g
          id="sauna_3-2"
          data-name="sauna_3"
          onClick={() => changeView(17, 'talosauna3')}
          onMouseOver={() => setElementOnHover('talosauna3')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <path
            className="cls-10"
            d="m105.6748,193.7402v-1.7188c.3115.2607.6494.457,1.0146.5879s.7344.1953,1.1064.1953c.2188,0,.4092-.0195.5723-.0586s.2988-.0938.4082-.1641c.1094-.0693.1904-.1523.2441-.2471s.0811-.1973.0811-.3086c0-.1504-.043-.2842-.1289-.4033-.0859-.1172-.2031-.2266-.3516-.3271-.1494-.1006-.3252-.1973-.5293-.29s-.4248-.1875-.6611-.2852c-.6016-.25-1.0498-.5566-1.3447-.918-.2959-.3613-.4434-.7988-.4434-1.3105,0-.4014.0801-.7461.2412-1.0342s.3809-.5254.6582-.7119c.2773-.1855.5986-.3223.9639-.4102s.752-.1318,1.1602-.1318c.4014,0,.7568.0244,1.0664.0723.3096.0488.5957.123.8564.2236v1.6055c-.1289-.0898-.2695-.168-.4209-.2363-.1523-.0684-.3096-.124-.4707-.1689s-.3213-.0781-.4805-.0996-.3105-.0322-.4541-.0322c-.1963,0-.376.0186-.5371.0566-.1611.0371-.2969.0898-.4082.1582-.1104.0684-.1963.1494-.2578.2441-.0605.0947-.0908.2012-.0908.3203,0,.1289.0342.2441.1016.3457.0684.1025.165.1992.29.29.126.0918.2773.1807.457.2686.1787.0879.3809.1787.6064.2715.3086.1289.585.2656.8301.4111.2451.1445.4561.3086.6309.4912.1758.1826.3096.3916.4033.626.0928.2344.1396.5068.1396.8193,0,.4297-.082.79-.2441,1.082-.1631.292-.3848.5283-.6641.709s-.6035.3105-.9746.3887c-.3701.0791-.7617.1191-1.1738.1191-.4219,0-.8242-.0361-1.2051-.1074-.3818-.0723-.7119-.1797-.9912-.3223Z"
          />
          <path
            className="cls-10"
            d="m116.6045,194.0352h-1.6055v-.7891h-.0215c-.3691.6152-.915.9238-1.6387.9238-.5332,0-.9531-.1514-1.2588-.4541-.3066-.3027-.46-.7061-.46-1.2119,0-1.0664.6318-1.6826,1.8965-1.8477l1.4932-.1982c0-.6016-.3262-.9023-.9775-.9023-.6553,0-1.2783.1953-1.8691.585v-1.2773c.2363-.1221.5596-.2295.9697-.3223.4092-.0938.7832-.1406,1.1191-.1406,1.5684,0,2.3525.7832,2.3525,2.3477v3.2871Zm-1.5947-2.2344v-.3711l-.999.1289c-.5518.0723-.8271.3213-.8271.7471,0,.1934.0674.3516.2012.4756.1348.123.3164.1855.5449.1855.3193,0,.5781-.1104.7793-.3311.2002-.2197.3008-.498.3008-.835Z"
          />
          <path
            className="cls-10"
            d="m123.1738,194.0352h-1.6924v-.8379h-.0264c-.4189.6484-.9795.9727-1.6816.9727-1.2744,0-1.9121-.7725-1.9121-2.3154v-3.3193h1.6924v3.1689c0,.7773.3076,1.165.9238,1.165.3037,0,.5479-.1064.7305-.3193s.2734-.502.2734-.8672v-3.1475h1.6924v5.5Z"
          />
          <path
            className="cls-10"
            d="m129.9141,194.0352h-1.6914v-3.0566c0-.8516-.3047-1.2773-.9131-1.2773-.2939,0-.5352.1123-.7256.3379-.1895.2256-.2842.5117-.2842.8594v3.1367h-1.6973v-5.5h1.6973v.8701h.0215c.4043-.6699.9932-1.0049,1.7666-1.0049,1.2178,0,1.8262.7559,1.8262,2.2676v3.3672Z"
          />
          <path
            className="cls-10"
            d="m135.833,194.0352h-1.6055v-.7891h-.0215c-.3691.6152-.915.9238-1.6387.9238-.5332,0-.9531-.1514-1.2588-.4541-.3066-.3027-.46-.7061-.46-1.2119,0-1.0664.6318-1.6826,1.8965-1.8477l1.4932-.1982c0-.6016-.3262-.9023-.9775-.9023-.6553,0-1.2783.1953-1.8691.585v-1.2773c.2363-.1221.5596-.2295.9697-.3223.4092-.0938.7832-.1406,1.1191-.1406,1.5684,0,2.3525.7832,2.3525,2.3477v3.2871Zm-1.5947-2.2344v-.3711l-.999.1289c-.5518.0723-.8271.3213-.8271.7471,0,.1934.0674.3516.2012.4756.1348.123.3164.1855.5449.1855.3193,0,.5781-.1104.7793-.3311.2002-.2197.3008-.498.3008-.835Z"
          />
          <path
            className="cls-10"
            d="m140.2861,193.7832v-1.4775c.5156.376,1.1172.5635,1.8047.5635.4326,0,.7705-.0928,1.0117-.2793.2422-.1855.3633-.4453.3633-.7783,0-.3438-.1494-.6084-.4492-.7949-.2988-.1865-.709-.2793-1.2324-.2793h-.6924v-1.2998h.6387c1.0029,0,1.5039-.333,1.5039-.999,0-.627-.3848-.9404-1.1543-.9404-.5156,0-1.0176.167-1.5039.5v-1.3857c.54-.2725,1.1709-.4082,1.8906-.4082.7871,0,1.4004.1768,1.8389.5322.4395.3535.6582.8145.6582,1.3799,0,1.0059-.5098,1.6367-1.5303,1.8906v.0264c.5439.0684.9736.2666,1.2891.5938.3145.3281.4727.7295.4727,1.2061,0,.7197-.2637,1.2891-.79,1.708s-1.2529.6289-2.1807.6289c-.7949,0-1.4414-.1289-1.9385-.3867Z"
          />
        </g>
        <g
          id="sauna_2-3"
          data-name="sauna_2"
          onClick={() => changeView(17, 'talokerho2')}
          onMouseOver={() => setElementOnHover('talokerho2')}
          onMouseLeave={() => setElementOnHover('')}
        >
          <path
            className="cls-10"
            d="m172.8721,194.0352h-2.1914l-2.2451-3.3457c-.043-.0645-.1104-.2061-.2041-.4248h-.0264v3.7705h-1.7354v-7.7021h1.7354v3.6416h.0264c.043-.1006.1152-.2432.2148-.4297l2.127-3.2119h2.0684l-2.6855,3.6738,2.916,4.0283Z"
          />
          <path
            className="cls-10"
            d="m178.3828,191.7686h-3.5879c.0576.7988.5605,1.1982,1.5098,1.1982.6045,0,1.1367-.1436,1.5947-.4297v1.2246c-.5078.2715-1.1689.4082-1.9814.4082-.8887,0-1.5771-.2471-2.0684-.7393-.4902-.4922-.7354-1.1787-.7354-2.0596,0-.9131.2646-1.6367.7949-2.1699.5293-.5332,1.1816-.8008,1.9551-.8008.8018,0,1.4219.2383,1.8613.7148.4385.4766.6572,1.123.6572,1.9395v.7139Zm-1.5732-1.042c0-.7881-.3193-1.1816-.9561-1.1816-.2725,0-.5078.1133-.7061.3379-.1992.2266-.3203.5068-.3633.8438h2.0254Z"
          />
          <path
            className="cls-10"
            d="m182.9805,190.0664c-.2041-.1113-.4424-.167-.7139-.167-.3691,0-.6572.1348-.8652.4053-.207.2705-.3115.6387-.3115,1.1035v2.627h-1.6973v-5.5h1.6973v1.0205h.0215c.2686-.7451.752-1.1172,1.4502-1.1172.1797,0,.3193.0215.4189.0645v1.5635Z"
          />
          <path
            className="cls-10"
            d="m189.0498,194.0352h-1.6914v-3.126c0-.8057-.2939-1.208-.8809-1.208-.3008,0-.5449.1123-.7305.3379-.1865.2256-.2793.5117-.2793.8594v3.1367h-1.6973v-8.1426h1.6973v3.459h.0215c.415-.6338.9795-.9512,1.6914-.9512,1.2461,0,1.8691.752,1.8691,2.2559v3.3789Z"
          />
          <path
            className="cls-10"
            d="m193.0137,194.1699c-.916,0-1.6367-.2578-2.1611-.7715-.5254-.5137-.7871-1.2109-.7871-2.0918,0-.9092.2715-1.6211.8164-2.1348.5439-.5137,1.2803-.7715,2.207-.7715.9131,0,1.6299.2578,2.1484.7715.5195.5137.7793,1.1934.7793,2.0381,0,.9131-.2676,1.6348-.8027,2.165-.5361.5293-1.2686.7949-2.2002.7949Zm.043-4.4688c-.4004,0-.7119.1377-.9346.4131-.2217.2754-.333.666-.333,1.1709,0,1.0566.4268,1.584,1.2783,1.584.8135,0,1.2197-.542,1.2197-1.627,0-1.0273-.4102-1.541-1.2305-1.541Z"
          />
          <path
            className="cls-10"
            d="m200.4424,193.9707c-.251.1328-.6289.1992-1.1338.1992-1.1953,0-1.7939-.6221-1.7939-1.8643v-2.5186h-.8916v-1.252h.8916v-1.1875l1.6924-.4824v1.6699h1.2354v1.252h-1.2354v2.2227c0,.5732.2275.8594.6816.8594.1797,0,.3633-.0518.5537-.1553v1.2568Z"
          />
          <path
            className="cls-10"
            d="m202.2578,187.665c-.2871,0-.5215-.085-.7041-.2549s-.2734-.3789-.2734-.626c0-.2539.0908-.4619.2734-.623s.417-.2412.7041-.2412c.29,0,.5254.0801.7061.2412s.2715.3691.2715.623c0,.2578-.0908.4688-.2715.6338s-.416.2471-.7061.2471Zm.8379,6.3701h-1.6973v-5.5h1.6973v5.5Z"
          />
          <path
            className="cls-10"
            d="m206.2217,194.0352h-1.6973v-8.1426h1.6973v8.1426Z"
          />
          <path
            className="cls-10"
            d="m212.2266,194.0352h-1.6064v-.7891h-.0215c-.3682.6152-.915.9238-1.6377.9238-.5342,0-.9541-.1514-1.2598-.4541-.3066-.3027-.459-.7061-.459-1.2119,0-1.0664.6318-1.6826,1.8955-1.8477l1.4932-.1982c0-.6016-.3252-.9023-.9775-.9023-.6553,0-1.2783.1953-1.8691.585v-1.2773c.2363-.1221.5596-.2295.9697-.3223.4102-.0938.7832-.1406,1.1201-.1406,1.5684,0,2.3525.7832,2.3525,2.3477v3.2871Zm-1.5957-2.2344v-.3711l-.999.1289c-.5508.0723-.8271.3213-.8271.7471,0,.1934.0674.3516.2012.4756.1348.123.3164.1855.5459.1855.3184,0,.5781-.1104.7783-.3311.2012-.2197.3008-.498.3008-.835Z"
          />
        </g>
      </g>
    </Floor17StyledSVG>
  )
}

const pivots = {
  talokerho2: [176.0829, 210.563],
  talosauna3: [124.9199, 210.563],
  talosauna2: [86.9182, 210.4849],
}
